import type { L, NavItem, Option } from '../types/content';

export const business = {
  name: 'Win21der',
  fullName: 'Win21der Painting Services',
  owner: 'Pablo Adame',
  phoneDisplay: '+1 (614) 382-9458',
  phoneShort: '614-382-9458',
  phoneHref: 'tel:+16143829458',
  phoneSchema: '+1-614-382-9458',
  email: 'info@win21der.com',
  street: '3431 Cleveland Ave',
  city: 'Columbus',
  region: 'OH',
  postalCode: '43224',
  addressLine: '3431 Cleveland Ave, Columbus, OH 43224',
  url: 'https://win21der.com',
  rating: 5.0,
  reviewCount: 12,
  mapsUrl:
    'https://www.google.com/maps/search/?api=1&query=Win21der+3431+Cleveland+Ave+Columbus+OH+43224',
};

export const images = {
  hero: 'https://cdn.magicpatterns.com/patterns/generated-images/ae5ea784-22df-40a4-bc34-9f84ba6e4ba6.jpg',
};

export const navItems: NavItem[] = [
  { label: { en: 'Home', es: 'Inicio' }, href: '#top' },
  {
    label: { en: 'Services', es: 'Servicios' },
    href: '#services',
    children: [
      {
        label: { en: 'Commercial Painting', es: 'Pintura Comercial' },
        description: { en: 'Offices, retail, warehouses & more', es: 'Oficinas, comercios, almacenes y más' },
        href: '#commercial-painting',
        market: 'commercial',
      },
      {
        label: { en: 'Residential Painting', es: 'Pintura Residencial' },
        description: { en: 'Interiors, exteriors & cabinets', es: 'Interiores, exteriores y gabinetes' },
        href: '#residential-painting',
        market: 'residential',
      },
    ],
  },
  { label: { en: 'About', es: 'Acerca' }, href: '#about' },
  { label: { en: 'Service Areas', es: 'Áreas de Servicio' }, href: '#service-areas' },
  { label: { en: 'FAQ', es: 'Preguntas' }, href: '#faq' },
  { label: { en: 'Contact', es: 'Contacto' }, href: '#contact' },
];

export type ProjectType = 'res-interior' | 'res-exterior' | 'com-interior' | 'com-exterior' | 'specialty' | 'other';
export type Timeline = 'asap' | '1-2-weeks' | '1-month' | 'flexible';

export const projectTypeOptions: Option<ProjectType>[] = [
  { value: 'res-interior', label: { en: 'Residential – Interior', es: 'Residencial – Interior' } },
  { value: 'res-exterior', label: { en: 'Residential – Exterior', es: 'Residencial – Exterior' } },
  { value: 'com-interior', label: { en: 'Commercial – Interior', es: 'Comercial – Interior' } },
  { value: 'com-exterior', label: { en: 'Commercial – Exterior', es: 'Comercial – Exterior' } },
  { value: 'specialty', label: { en: 'Specialty / Drywall', es: 'Especial / Drywall' } },
  { value: 'other', label: { en: 'Other', es: 'Otro' } },
];

export const timelineOptions: Option<Timeline>[] = [
  { value: 'asap', label: { en: 'As soon as possible', es: 'Lo antes posible' } },
  { value: '1-2-weeks', label: { en: '1–2 weeks', es: '1–2 semanas' } },
  { value: '1-month', label: { en: 'Within 1 month', es: 'En 1 mes' } },
  { value: 'flexible', label: { en: 'Flexible', es: 'Flexible' } },
];

export const footerLinks: { label: L; href: string }[] = [
  { label: { en: 'Home', es: 'Inicio' }, href: '#top' },
  { label: { en: 'Commercial Painting', es: 'Pintura Comercial' }, href: '#commercial-painting' },
  { label: { en: 'Residential Painting', es: 'Pintura Residencial' }, href: '#residential-painting' },
  { label: { en: 'Service Areas', es: 'Áreas de Servicio' }, href: '#service-areas' },
  { label: { en: 'FAQ', es: 'Preguntas' }, href: '#faq' },
  { label: { en: 'About', es: 'Acerca' }, href: '#about' },
  { label: { en: 'Contact', es: 'Contacto' }, href: '#contact' },
];

export const footerServices: { title: L; href: string; items: L[] }[] = [
  {
    title: { en: 'Commercial', es: 'Comercial' },
    href: '#commercial-painting',
    items: [
      { en: 'Interior Painting', es: 'Pintura Interior' },
      { en: 'Exterior Painting', es: 'Pintura Exterior' },
      { en: 'Specialty Coatings', es: 'Recubrimientos Especiales' },
      { en: 'Drywall Repair', es: 'Reparación de Drywall' },
    ],
  },
  {
    title: { en: 'Residential', es: 'Residencial' },
    href: '#residential-painting',
    items: [
      { en: 'Interior Painting', es: 'Pintura Interior' },
      { en: 'Exterior Painting', es: 'Pintura Exterior' },
      { en: 'Cabinet & Specialty', es: 'Gabinetes y Especiales' },
    ],
  },
];
